module.exports = __webpack_public_path__ + "media/images/posts/kazas-divata-f8d1abe99ce0a4fe76cf3c4840865778.jpg";